import React, { useContext } from "react";
import ThemeContext from "../context/ThemeContext";
import { ThemeInterface } from "../services/exports/Interfaces";

export default function useTheme() {
  const theme: ThemeInterface = useContext(ThemeContext);
  return theme;
}
